<template>
  <iframe id="iframe3D" style="width: 100%; height: 100%; border: none; overflow: hidden;"
    :src="`/view/index.html?data=${dataId}&placeholder=false`"></iframe>
</template>

<script>

const getLevel = (num) => {
  let level = "A"
  switch (num) {
    case 1:
      level = "B";
      break;
    case 2:
      level = "C";
      break;
    case 3:
      level = "D";
      break;
  }
  return level;
}

export default {
  name: "Meta2d",
  data() {
    return {
      dataId: this.$route.query.id || "3d.json",
    };
  },
  mounted() {
    var serverUrl = localStorage.serverUrl;
    var bigScreenApiUrl = `${serverUrl}AIWeighing/GetBigScreenData`;
    let isRemoveCamera = false;
    function initContents(mesh, hasCGQ) {
      const contents = [];
      let offsetY = 170;
      let top = 220;
      let datas;
      // console.log(mesh.id, hasCGQ)
      if (hasCGQ) {
        mesh.scaling.y = 25;
        mesh.height = 1200;
        mesh.imageSource = "./信息面板.png";
        top = 180;
        datas = [
          { property: "名称", value: "" },
          { property: "棒码状态", value: "" },
          { property: "电机1状态", value: "" },
          { property: "电机2状态", value: "" },
          { property: "传感器", value: "" },
          { property: "通讯状态", value: "" },
          { property: "托辊状态", value: "" },
          { property: "温度", value: "" },
        ];
        offsetY = 120;
      } else {
        datas = [
          { property: "名称", value: "" },
          { property: "棒码状态", value: "" },
          { property: "电机1状态", value: "" },
          { property: "电机2状态", value: "" },
        ];
      }
      datas.forEach((data, index) => {
        const contentProperty = {
          "id": Math.random(),
          "name": data.property,
          "type": "text",
          "width": 300,
          "height": 100,
          "left": 143,
          "top": top + index * offsetY,
          "backgroundColor": "rgba(255, 255, 255, 0)",
          "alpha": 1,
          "text": data.property,
          "color": "rgba(255, 255, 255, 1)",
          "fontSize": "50px",
          "fontWeight": "500",
          "textAlign": "start",
          "verticalAlign": "center"
        };
        const contentValue = {
          "id": Math.random(),
          "name": data.property + "值",
          "type": "text",
          "width": 400,
          "height": 100,
          "left": 540,
          "top": top + index * offsetY,
          "backgroundColor": "rgba(255, 255, 255, 0)",
          "alpha": 1,
          "text": data.value,
          "color": "rgba(255, 255, 255, 1)",
          "fontSize": "50px",
          "fontWeight": "500",
          "textAlign": "center",
          "verticalAlign": "center"
        };
        contents.push(contentProperty);
        contents.push(contentValue)
      })
      return contents;
    }

    const iframe3D = document.getElementById("iframe3D");
    if (iframe3D.contentWindow) {

      iframe3D.contentWindow.initScene = () => {
        function fetchData() {
          var beltScaleGuid = $('#beltScaleSelector').val();
          if (!beltScaleGuid) return;
          fetch(`${bigScreenApiUrl}?beltScaleGuid=${beltScaleGuid}`, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${localStorage.token}`,
              'Content-Type': 'application/json'
            }
          })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(beltScaleData => {
              const manager = (iframe3D.contentWindow).manager;
              (window).manager = manager;
              window.attachControl = () => {
                manager.scene.scene.activeCamera.attachControl();
              }
              window.detachControl = () => {
                manager.scene.scene.activeCamera.detachControl();
              }
              const dataSetId = "915be30";
              // console.log("dataSetId", dataSetId);
              const dataSet = (iframe3D.contentWindow).manager.root.datasetManager.datasetInstances.get(dataSetId);
              // dataSet.disconnect();
              // dataSet.mockable = false;
              // dataSet.connect();
              const datasetManager = (iframe3D.contentWindow).manager.root.datasetManager;
              const scene = (iframe3D.contentWindow).manager.scene.scene;
              (window).scene = scene;
              scene.onPointerObservable.add((e, p) => {
                if (e.type === 1) {

                  if (e.pickInfo.pickedPoint) {
                    // console.log("pick")
                    manager.setValue({
                      target: manager.scene,
                      props:
                        [
                          { property: ['cameraTargetX'], value: e.pickInfo.pickedPoint.x },
                          { property: ['cameraTargetY'], value: e.pickInfo.pickedPoint.y },
                          { property: ['cameraTargetZ'], value: e.pickInfo.pickedPoint.z },
                        ],
                    },
                      { duration: 0.5 }
                    )
                    // scene.activeCamera.target = e.pickInfo.pickedPoint.clone();
                  }

                  // console.log(e, p);
                }
              })
              const mesh_cj = []
              const mesh_cj_A_A = scene.getMeshById("称架A-托辊A-称重");
              const mesh_cj_A_B = scene.getMeshById("称架A-托辊B-称重");

              const mesh_cj_B_A = scene.getMeshById("称架B-托辊A-称重");
              const mesh_cj_B_B = scene.getMeshById("称架B-托辊B-称重");
              const mesh_cj_C_A = scene.getMeshById("称架C-托辊A-称重");
              const mesh_cj_C_B = scene.getMeshById("称架C-托辊B-称重");

              const mesh_cj_D_A = scene.getMeshById("称架D-托辊A-称重");
              const mesh_cj_D_B = scene.getMeshById("称架D-托辊B-称重");
              const speedMes = scene.getMeshById("速度传感器_信息");
              const meshJPQDMes = scene.getMeshById("纠偏装置01_起点_信息");
              const meshJPZDMes = scene.getMeshById("纠偏装置02_终点_信息");
              const mirror = scene.getMeshById("le5le_Mirror");
              // window.mirror = mirror;
              mirror.visiabilty = 0;
              mirror.setEnabled(false);
              const meshJPQD = scene.getMeshById("纠偏装置01_起点");
              const meshJPZD = scene.getMeshById("纠偏装置02_终点");

              const meshSpeed = scene.getMeshById("带底座速度传感器");

              const data = beltScaleData.data.list[0].beltScaleModelData;
              const result = data;
              //修改倒影平面的颜色；
              // mirror.material.ambientColor.fromHexString("#00ff00");
              //销毁倒影平面
              // mirror.setEnabled(false);


              scene.clearColor.a = 0;
              mirror.scaling.z = 0.05;
              mirror.scaling.x = 0.0075;
              mirror.scaling.y = 0.015;
              mirror.position.z = -10;
              // scene.activeCamera.zoomOnFactor = 0.1;
              // scene.activeCamera.zoomOn()

              mesh_cj.push(mesh_cj_A_A);
              mesh_cj.push(mesh_cj_A_B);
              mesh_cj.push(mesh_cj_B_A);
              mesh_cj.push(mesh_cj_B_B);

              mesh_cj.push(mesh_cj_C_A);
              mesh_cj.push(mesh_cj_C_B);
              mesh_cj.push(mesh_cj_D_A);
              mesh_cj.push(mesh_cj_D_B);

              const dm = []
              // const mesh_dg = backPosition(scene, "底轨", 110);
              // mesh_dg.scaling.z = 0.5
              // dm.push(mesh_dg);
              const JPQDAni = scene.animationGroups[7];
              const JPZDAni = scene.animationGroups[6];
              const JPStatus = {
                LEFT: 1,
                RIGHT: 2,
                NONE: 0
                //0:正常，1:左偏，2:右偏)
              };
              let nowQDTo = 0;
              let nowZDTo = 0;
              (window).playQDAni = playQDAn;
              function playQDAn(status, from, to) {
                if (JPQDAni.isPlaying) {
                  JPQDAni.stop();
                }

                if (status == JPStatus.NONE) {
                  JPQDAni.from = nowQDTo;
                  JPQDAni.to = 150;
                  nowQDTo = 150;
                  // JPQDAni.speedRadio = 1;
                  JPQDAni.start();
                } else if (status == JPStatus.LEFT) {
                  JPQDAni.from = nowQDTo;
                  JPQDAni.to = 300;
                  nowQDTo = 300;
                  // JPQDAni.speedRadio = 1;
                  JPQDAni.start();
                } else {
                  JPQDAni.from = 0;
                  JPQDAni.to = nowQDTo;
                  nowQDTo = 0;

                  // JPQDAni.speedRadio = -1;
                  JPQDAni.start(false, -1);

                }
              }
              (window).playZDAn = playZDAn;
              function playZDAn(status, from, to) {
                if (JPZDAni.isPlaying) {
                  JPZDAni.stop();
                }

                if (status == JPStatus.NONE) {
                  JPZDAni.from = nowZDTo;
                  JPZDAni.to = 150;
                  nowZDTo = 150;
                  // JPZDAni.speedRadio = 1;
                  JPZDAni.start();
                } else if (status == JPStatus.LEFT) {
                  JPZDAni.from = nowZDTo;
                  JPZDAni.to = 300;
                  nowZDTo = 300;
                  // JPZDAni.speedRadio = 1;
                  JPZDAni.start();
                } else {
                  JPZDAni.from = 0;
                  JPZDAni.to = nowZDTo;
                  nowZDTo = 0;

                  // JPZDAni.speedRadio = -1;
                  JPZDAni.start(false, -1);

                }
              }

              const promises = [];
              if (!isRemoveCamera) {
                isRemoveCamera = true;
                manager.showCameraView(manager.allCameraViews().find(v => v.name === data.beltScaleData.scaleRackGroups.length + "组").id, {
                  duration: 2
                });

              };
              ["底轨", "皮带_空", "皮带满", "皮带_少"].forEach((name) => {
                // const mesh = backPosition(scene, name,110);
                promises.push(new Promise((re) => {
                  setTimeout(() => {
                    const mesh = scene.getMeshById(name);
                    // console.log("data.beltScaleData.scaleRackGroups", data.beltScaleData.scaleRackGroups.length);
                    switch (data.beltScaleData.scaleRackGroups.length) {
                      case 1:
                        mesh.scaling.z = 0.7;
                        mesh.position.z = -76;
                        break;
                      case 2:
                        mesh.scaling.z = 1;
                        mesh.position.z = -48;
                        break;
                      case 3:
                        mesh.scaling.z = 1.2;
                        mesh.position.z = -20;
                        break
                      case 4:
                        mesh.scaling.z = 1.35;
                        mesh.position.z = 6.5;
                      // break

                      default:
                        break;
                    }


                    if (!result.beltScaleData.speedSensor.display) {
                      mesh.scaling.z -= 0.05;
                      mesh.position.z -= 10;
                    }

                    if (result.beltScaleData.offsetCorrections.length > 0) {
                      if (!result.beltScaleData.offsetCorrections[0].display) {
                        mesh.scaling.z -= 0.2;
                        mesh.position.z += 20;
                      }
                      if (!result.beltScaleData.offsetCorrections[1].display) {
                        mesh.scaling.z -= 0.2;
                        mesh.position.z -= 20;
                      }
                    }
                    // dm.push(mesh);
                    // mesh.rotation.y = Math.PI;
                    // mesh.position.z = -110+27.5*data.beltScaleData.scaleRackGroups.length;
                    re(mesh)
                    // mesh.scaling.z = 0.5
                  }, 10)
                }))
              })


              Promise.all(promises).then(() => {

                dm.forEach((mesh) => {
                  mesh.scaling.z = result.beltScaleData.scaleRackGroups.length / 4;
                  mesh.getChildMeshes().forEach((cm) => {
                    if (cm.material.albedoTexture) {
                      cm.material.albedoTexture.vScale = 4 / result.beltScaleData.scaleRackGroups.length;
                    }
                  })
                })
                for (let index = result.beltScaleData.scaleRackGroups.length; index < 4; index++) {

                  mesh_cj[(index) * 2].setEnabled(false);
                  mesh_cj[(index) * 2 + 1].setEnabled(false);
                }
                mirror.scaling.z = result.beltScaleData.scaleRackGroups.length * 0.01;
                let offset = result.beltScaleData.speedSensor.display ? 30 : 0;
                switch (result.beltScaleData.scaleRackGroups.length) {

                  case 1:
                    // mirror.position.z = -60;
                    meshSpeed.position.z = -40;
                    meshJPZD.position.z = 310 - (4 - 1) * 55;

                    break;
                  case 2:
                    // mirror.position.z = -35;
                    meshSpeed.position.z = 10;
                    meshJPZD.position.z = 310 - (4 - 2) * 55;
                    break;
                  case 3:
                    // mirror.position.z = 15;
                    meshSpeed.position.z = 62;
                    meshJPZD.position.z = 310 - (4 - 3) * 55;
                    break
                  case 4:
                    // meshJPZD.position.z = -195 + offset + 54 * 3;
                    break
                  default:
                    break;
                }
                if (!result.beltScaleData.speedSensor.display) {
                  meshJPZD.position.z -= 30;
                }

                const center1 = (meshSpeed.getHierarchyBoundingVectors().max.z + meshSpeed.getHierarchyBoundingVectors().min.z) * .5;
                const center2 = (meshJPZD.getHierarchyBoundingVectors().max.z + meshJPZD.getHierarchyBoundingVectors().min.z) * .5
                speedMes.position.z = center1;
                meshJPZDMes.position.z = center2;
                // console.log("meshSpeed", result.beltScaleData.scaleRackGroups.length, meshSpeed.position.z)
                // mirror.position.z -=27.5*(4-result.beltScaleData.scaleRackGroups.length)
                // scene.activeCamera.target = (mesh_dg.getBoundingInfo().boundingBox.centerWorld);

                // window.datasetManager = datasetManager;
                datasetManager.
                  setValue(dataSetId, "isOffTrack", result.beltScaleData.isOffTrack);

                // datasetManager.
                //   setValue(dataSetId, "scrollState", 0);
                // datasetManager.
                //   setValue(dataSetId, "scrollState", 1);
                datasetManager.
                  setValue(dataSetId, "scrollState", Math.abs(result.beltScaleData.scrollState - 1));

                datasetManager.
                  setValue(dataSetId, "coalQuantity", 1);

                datasetManager.
                  setValue(dataSetId, "coalQuantity", result.beltScaleData.coalQuantity);

                result.beltScaleData.scaleRackGroups.forEach((d, index) => {
                  //是否有棒码数据点绑定
                  datasetManager.
                    setValue(dataSetId, "isThereRodWeight-" + (index + 1), d.isThereRodWeight);
                  // console.log("scaleRackRollersDatas", d.scaleRackRollersDatas)
                  if (d.scaleRackRollersDatas.length > 0) {

                    datasetManager.
                      setValue(dataSetId, `isAbnormal-${getLevel(index)}-A-1`,
                        d.scaleRackRollersDatas[0].scaleRackRollersElectricMotorDatas[0].isAbnormal);
                    datasetManager.
                      setValue(dataSetId, `isAbnormal-${getLevel(index)}-A-2`,
                        d.scaleRackRollersDatas[0].scaleRackRollersElectricMotorDatas[1].isAbnormal);

                    datasetManager.
                      setValue(dataSetId, `isAbnormal-${getLevel(index)}-B-1`, d.scaleRackRollersDatas[1].scaleRackRollersElectricMotorDatas[0].isAbnormal);
                    datasetManager.
                      setValue(dataSetId, `isAbnormal-${getLevel(index)}-B-2`, d.scaleRackRollersDatas[1].scaleRackRollersElectricMotorDatas[1].isAbnormal);

                    const level = getLevel(index);
                    // console.log(`is-${level}-shockSensor1-display`, d.scaleRackRollersDatas[0].shockSensor.display);
                    datasetManager.
                      setValue(dataSetId, `is-${level}-shockSensor1-display`,
                        d.scaleRackRollersDatas[0].shockSensor.display);
                    datasetManager.
                      setValue(dataSetId, `is-${level}-shockSensor1-warning`,
                        d.scaleRackRollersDatas[0].shockSensor.isAbnormal == 1 ? true : false);

                    datasetManager.
                      setValue(dataSetId, `is-${level}-shockSensor2-display`,
                        d.scaleRackRollersDatas[1].shockSensor.display);
                    datasetManager.
                      setValue(dataSetId, `is-${level}-shockSensor2-warning`,
                        d.scaleRackRollersDatas[1].shockSensor.isAbnormal == 1 ? true : false);


                    //称架A-托辊A_信息
                    const mesh_info1 = scene.getMeshById(`称架${getLevel(index)}-托辊A_信息`);

                    const mesh_info2 = scene.getMeshById(`称架${getLevel(index)}-托辊B_信息`);


                    // console.log("mesh_info1", mesh_info1)
                    //托辊A状态；


                    const mesh_TG_A = scene.getMeshesById(`棒码`).find(m => m.parent.id == `称架${getLevel(index)}-托辊A-称重`);
                    const mesh_DJ_A_1 = scene.getTransformNodesById(`左电机`).find(m => m.parent.id == `称架${getLevel(index)}-托辊A-称重`);
                    const mesh_DJ_A_2 = scene.getTransformNodesById(`右电机`).find(m => m.parent.id == `称架${getLevel(index)}-托辊A-称重`);
                    const mesh_DJ_B_1 = scene.getTransformNodesById(`左电机`).find(m => m.parent.id == `称架${getLevel(index)}-托辊B-称重`);
                    const mesh_DJ_B_2 = scene.getTransformNodesById(`右电机`).find(m => m.parent.id == `称架${getLevel(index)}-托辊B-称重`);

                    //称重
                    const mesh_CZ_A_1 = scene.getMeshesById(`左称重`).find(m => m.parent.id == `称架${getLevel(index)}-托辊A-称重`);
                    const mesh_CZ_A_2 = scene.getMeshesById(`右称重`).find(m => m.parent.id == `称架${getLevel(index)}-托辊A-称重`);
                    const mesh_CZ_B_1 = scene.getMeshesById(`左称重`).find(m => m.parent.id == `称架${getLevel(index)}-托辊B-称重`);
                    const mesh_CZ_B_2 = scene.getMeshesById(`右称重`).find(m => m.parent.id == `称架${getLevel(index)}-托辊B-称重`);
                    if (d.scaleRackRollersDatas[0].loadCells.length < 1) {
                      mesh_CZ_A_1.setEnabled(false);
                      mesh_CZ_A_2.setEnabled(false);
                    } else {

                      mesh_CZ_A_1.setEnabled(d.scaleRackRollersDatas[0].loadCells[0].display);
                      mesh_CZ_A_2.setEnabled(d.scaleRackRollersDatas[0].loadCells[1].display);
                    };

                    if (d.scaleRackRollersDatas[1].loadCells.length < 1) {
                      mesh_CZ_B_1.setEnabled(false);
                      mesh_CZ_B_2.setEnabled(false);
                    } else {
                      mesh_CZ_B_1.setEnabled(d.scaleRackRollersDatas[1].loadCells[0].display);
                      mesh_CZ_B_2.setEnabled(d.scaleRackRollersDatas[1].loadCells[0].display);
                    };






                    //称重告警 逻辑；
                    const meshParent_A = scene.getMeshById(`称架${getLevel(index)}-托辊A-称重`);
                    const gjdh_A_l = manager.getMetadata(meshParent_A).animations.find(d => d.name == "左称重告警").id;
                    const gjdh_A_r = manager.getMetadata(meshParent_A).animations.find(d => d.name == "右称重告警").id;
                    if (d.scaleRackRollersDatas[0].loadCells[0].status == 1) {
                      manager.animateManager.begin(meshParent_A, gjdh_A_l)
                    } else {
                      manager.animateManager.stop(meshParent_A, gjdh_A_l)
                    };
                    if (d.scaleRackRollersDatas[0].loadCells[1].status == 1) {
                      manager.animateManager.begin(meshParent_A, gjdh_A_r)
                    } else {
                      manager.animateManager.stop(meshParent_A, gjdh_A_r)
                    };

                    const meshParent_B = scene.getMeshById(`称架${getLevel(index)}-托辊B-称重`);
                    const gjdh_B_l = manager.getMetadata(meshParent_B).animations.find(d => d.name == "左称重告警").id;
                    const gjdh_B_r = manager.getMetadata(meshParent_B).animations.find(d => d.name == "右称重告警").id;
                    if (d.scaleRackRollersDatas[1].loadCells[0].status == 1) {
                      manager.animateManager.begin(meshParent_B, gjdh_B_l)
                    } else {
                      manager.animateManager.stop(meshParent_B, gjdh_B_l)
                    };
                    if (d.scaleRackRollersDatas[1].loadCells[1].status == 1) {
                      manager.animateManager.begin(meshParent_B, gjdh_B_r)
                    } else {
                      manager.animateManager.stop(meshParent_B, gjdh_B_r)
                    };

                    if (result.beltScaleData.offsetCorrections.length > 0) {
                      //纠偏设备交互
                      //0:正常，1:左偏，2:右偏)
                      //hydraulicGaugeAVal
                      if (result.beltScaleData.offsetCorrections[0]) {

                        datasetManager.
                          setValue(dataSetId, "isWarn-right", result.beltScaleData.offsetCorrections[0].status == 2);

                        datasetManager.
                          setValue(dataSetId, "isWarn-left", result.beltScaleData.offsetCorrections[0].status == 1);

                        datasetManager.
                          setValue(dataSetId, "isRoll-right",
                            result.beltScaleData.offsetCorrections[0].hydraulicGaugeAVal
                            > result.beltScaleData.offsetCorrections[0].hydraulicGaugeBVal);
                        datasetManager.
                          setValue(dataSetId, "isRoll-left", result.beltScaleData.offsetCorrections[0].hydraulicGaugeAVal
                            < result.beltScaleData.offsetCorrections[0].hydraulicGaugeBVal);
                        playQDAn(result.beltScaleData.offsetCorrections[0].status);

                      }

                      if (result.beltScaleData.offsetCorrections[1]) {

                        datasetManager.
                          setValue(dataSetId, "isWarn-right01", result.beltScaleData.offsetCorrections[1].status == 2);

                        datasetManager.
                          setValue(dataSetId, "isWarn-left01", result.beltScaleData.offsetCorrections[1].status == 1);

                        datasetManager.
                          setValue(dataSetId, "isRoll-right01",
                            result.beltScaleData.offsetCorrections[1].hydraulicGaugeAVal
                            > result.beltScaleData.offsetCorrections[1].hydraulicGaugeBVal);
                        datasetManager.
                          setValue(dataSetId, "isRoll-left01", result.beltScaleData.offsetCorrections[1].hydraulicGaugeAVal
                            < result.beltScaleData.offsetCorrections[1].hydraulicGaugeBVal);
                        playZDAn(result.beltScaleData.offsetCorrections[1].status);

                      }



                    }

                    // loadCells
                    setTG(d.scaleRackRollersDatas[0].rodWeightStatus, mesh_TG_A, manager);
                    setTG(d.scaleRackRollersDatas[0].scaleRackRollersElectricMotorDatas[0].rollersElectricMotorStatus, mesh_DJ_A_1, manager);
                    setTG(d.scaleRackRollersDatas[0].scaleRackRollersElectricMotorDatas[1].rollersElectricMotorStatus, mesh_DJ_A_2, manager);
                    setTG(d.scaleRackRollersDatas[1].scaleRackRollersElectricMotorDatas[0].rollersElectricMotorStatus, mesh_DJ_B_1, manager);
                    setTG(d.scaleRackRollersDatas[1].scaleRackRollersElectricMotorDatas[1].rollersElectricMotorStatus, mesh_DJ_B_2, manager);
                    //--------------
                    const contents = initContents(mesh_info1, d.scaleRackRollersDatas[0].shockSensor.display);
                    /* 名称 */
                    contents[1].text = d.scaleRackRollersDatas[0].name;
                    /* 棒码状态 */
                    contents[3].text = d.scaleRackRollersDatas[0].rodWeightStatus < 2 ? d.scaleRackRollersDatas[0].rodWeightStatus == 0 ? "升起" : "下降" : "异常";
                    if (contents[3].text == "异常") {
                      contents[3].color = "red";
                    } else {
                      contents[3].color = "rgba(20, 255, 0, 1)";
                    }
                    //电机A组1状态：

                    if (d.scaleRackRollersDatas[0].scaleRackRollersElectricMotorDatas[0].isAbnormal) {
                      contents[5].color = "red";
                      contents[5].text = "异常";
                    } else {
                      contents[5].color = "rgba(20, 255, 0, 1)";
                      if (d.scaleRackRollersDatas[0].scaleRackRollersElectricMotorDatas[0].rollersElectricMotorStatus == 0) {
                        contents[5].text = "升起";
                      } else {
                        contents[5].text = "落下";
                      }
                    }
                    //电机2状态：
                    if (d.scaleRackRollersDatas[0].scaleRackRollersElectricMotorDatas[1].isAbnormal) {
                      contents[7].color = "red";
                      contents[7].text = "异常"
                    } else {
                      contents[7].color = "rgba(20, 255, 0, 1)";
                      if (d.scaleRackRollersDatas[0].scaleRackRollersElectricMotorDatas[1].rollersElectricMotorStatus == 0) {
                        contents[7].text = "升起";
                      } else {
                        contents[7].text = "落下";
                      }
                    };
                    /*震动传感器  */
                    if (d.scaleRackRollersDatas[0].shockSensor.display) {
                      contents[9].text = d.scaleRackRollersDatas[0].shockSensor.name;
                      contents[11].text = d.scaleRackRollersDatas[0].shockSensor.isOnline == 2 ? "在线" : '离线';
                      contents[11].color = d.scaleRackRollersDatas[0].shockSensor.isOnline == 2 ? "rgba(20, 255, 0, 1)" : "red";
                      contents[13].text = d.scaleRackRollersDatas[0].shockSensor.isAbnormal == 0 ? '正常' : "异常";
                      contents[13].color = d.scaleRackRollersDatas[0].shockSensor.isAbnormal == 0 ? "rgba(20, 255, 0, 1)" : "red";
                      contents[15].text = d.scaleRackRollersDatas[0].shockSensor.temp + "℃";
                    }
                    mesh_info1.contents = contents;


                    //托辊B状态；
                    //设置托辊姿态
                    const mesh_TG_B = scene.getMeshesById(`棒码`).find(m => m.parent.id == `称架${getLevel(index)}-托辊B-称重`);;
                    setTG(d.scaleRackRollersDatas[1].rodWeightStatus, mesh_TG_B, manager);


                    const content2s = initContents(mesh_info2, d.scaleRackRollersDatas[1].shockSensor.display);
                    /* 名称 */
                    content2s[1].text = d.scaleRackRollersDatas[1].name;


                    content2s[3].text = d.scaleRackRollersDatas[1].rodWeightStatus < 2 ? d.scaleRackRollersDatas[1].rodWeightStatus == 0 ? "升起" : "下降" : "异常";
                    // console.log("123", d.scaleRackRollersDatas[1].rodWeightStatus < 2 ? d.scaleRackRollersDatas[1].rodWeightStatus == 0 ? "升起" : "下降" : "异常");
                    if (content2s[3].text == "异常") {
                      content2s[3].color = "red";
                      // console.log("异常")
                    } else {
                      // console.log("正常工作");
                      content2s[3].color = "rgba(20, 255, 0, 1)";
                    }
                    //--------------
                    //电机B组1状态：
                    if (d.scaleRackRollersDatas[1].scaleRackRollersElectricMotorDatas[0].isAbnormal) {
                      content2s[5].color = "red";
                      content2s[5].text = "异常"
                    } else {
                      content2s[5].color = "rgba(20, 255, 0, 1)";
                      if (d.scaleRackRollersDatas[1].scaleRackRollersElectricMotorDatas[0].rollersElectricMotorStatus == 0) {
                        content2s[5].text = "升起";
                      } else {
                        content2s[5].text = "落下";
                      }
                    }
                    //电机2状态：
                    if (d.scaleRackRollersDatas[1].scaleRackRollersElectricMotorDatas[1].isAbnormal) {
                      content2s[7].color = "red";
                      content2s[7].text = "异常"
                    } else {
                      content2s[7].color = "rgba(20, 255, 0, 1)";
                      if (d.scaleRackRollersDatas[1].scaleRackRollersElectricMotorDatas[1].rollersElectricMotorStatus == 0) {
                        content2s[7].text = "升起";
                      } else {
                        content2s[7].text = "落下";
                      }
                    }
                    /*震动传感器  */
                    if (d.scaleRackRollersDatas[1].shockSensor.display) {
                      content2s[9].text = d.scaleRackRollersDatas[1].shockSensor.name;
                      content2s[11].text = d.scaleRackRollersDatas[1].shockSensor.isOnline == 2 ? "在线" : '离线';
                      content2s[11].color = d.scaleRackRollersDatas[1].shockSensor.isOnline == 2 ? "rgba(20, 255, 0, 1)" : "red";
                      content2s[13].text = d.scaleRackRollersDatas[1].shockSensor.isAbnormal == 0 ? '正常' : "异常";
                      content2s[13].color = d.scaleRackRollersDatas[1].shockSensor.isAbnormal == 0 ? "rgba(20, 255, 0, 1)" : "red";
                      content2s[15].text = d.scaleRackRollersDatas[1].shockSensor.temp + "℃";
                    }
                    mesh_info2.contents = content2s;

                    if (result.beltScaleData.speedSensor.display) {
                      meshSpeed.setEnabled(true);
                      let speedStauts = '正常';
                      speedMes.contents[6].color = "rgba(20, 255, 0, 1)"
                      if (result.beltScaleData.speedSensor.status > 0) {
                        speedStauts = '异常';
                        speedMes.contents[6].color = "red";
                      }
                      speedMes.contents[3].text = result.beltScaleData.speedSensor.speed + "米/秒";
                      speedMes.contents[3].width = "400px";
                      speedMes.contents[3].left = "540px";
                      speedMes.contents[3].textAlign = "center";
                      speedMes.contents[6].text = speedStauts;
                      speedMes.contents[0].text = "速度传感器";
                      speedMes.contents = speedMes.contents;
                      /* 
                      content[3]="液压值01"
                      content[7]="液压值02"
                      content[1]="状态"
                      content[0]="面板名称"
                      */

                    } else {
                      meshSpeed.setEnabled(false);
                    }
                    if (result.beltScaleData.offsetCorrections.length > 0) {
                      /* 头部纠偏设备接入 */
                      if (result.beltScaleData.offsetCorrections[0].display) {
                        meshJPQD.setEnabled(true);
                        meshJPQDMes.contents[3].text = result.beltScaleData.offsetCorrections[0].hydraulicGaugeAVal;
                        meshJPQDMes.contents[11].text = result.beltScaleData.offsetCorrections[0].hydraulicGaugeBVal;


                        meshJPQDMes.contents[5].text = result.beltScaleData.offsetCorrections[0].status;
                        if (result.beltScaleData.offsetCorrections[0].status == 0) {

                          meshJPQDMes.contents[5].text = "正常";
                          meshJPQDMes.contents[5].color = "rgba(20, 255, 0, 1)";

                        } else {
                          let status = result.beltScaleData.offsetCorrections[0].status == 1 ? "左偏" : "右偏"
                          meshJPQDMes.contents[5].text = status;
                          meshJPQDMes.contents[5].color = "red";
                        }

                        if (result.beltScaleData.offsetCorrections[0].hydraulicGaugeAStatus == 0) {

                          meshJPQDMes.contents[7].text = "正常";
                          meshJPQDMes.contents[7].color = "rgba(20, 255, 0, 1)";

                        } else {
                          meshJPQDMes.contents[7].text = "异常";
                          meshJPQDMes.contents[7].color = "red";
                        }
                        if (result.beltScaleData.offsetCorrections[0].hydraulicGaugeBStatus == 0) {

                          meshJPQDMes.contents[10].text = "正常";
                          meshJPQDMes.contents[10].color = "rgba(20, 255, 0, 1)";

                        } else {
                          meshJPQDMes.contents[10].text = "异常";
                          meshJPQDMes.contents[10].color = "red";
                        }

                        meshJPQDMes.contents[0].text = result.beltScaleData.offsetCorrections[0].name;
                        meshJPQDMes.contents = meshJPQDMes.contents;
                      } else {
                        meshJPQD.setEnabled(false);
                      }

                      /* 尾部纠偏设备接入 */

                      if (result.beltScaleData.offsetCorrections[1].display) {
                        meshJPZD.setEnabled(true);
                        meshJPZDMes.contents[3].text = result.beltScaleData.offsetCorrections[1].hydraulicGaugeAVal;
                        meshJPZDMes.contents[11].text = result.beltScaleData.offsetCorrections[1].hydraulicGaugeBVal;


                        meshJPZDMes.contents[5].text = result.beltScaleData.offsetCorrections[1].status;
                        if (result.beltScaleData.offsetCorrections[1].status == 0) {

                          meshJPZDMes.contents[5].text = "正常";
                          meshJPZDMes.contents[5].color = "rgba(20, 255, 0, 1)";

                        } else {
                          let status = result.beltScaleData.offsetCorrections[1].status == 1 ? "左偏" : "右偏"
                          meshJPZDMes.contents[5].text = status;
                          meshJPZDMes.contents[5].color = "red";
                        }

                        if (result.beltScaleData.offsetCorrections[1].hydraulicGaugeAStatus == 0) {
                          meshJPZDMes.contents[7].text = "正常";
                          meshJPZDMes.contents[7].color = "rgba(20, 255, 0, 1)";

                        } else {
                          meshJPZDMes.contents[7].text = "异常";
                          meshJPZDMes.contents[7].color = "red";
                        }
                        if (result.beltScaleData.offsetCorrections[1].hydraulicGaugeBStatus == 0) {

                          meshJPZDMes.contents[10].text = "正常";
                          meshJPZDMes.contents[10].color = "rgba(20, 255, 0, 1)";

                        } else {
                          meshJPZDMes.contents[10].text = "异常";
                          meshJPZDMes.contents[10].color = "red";
                        }

                        meshJPZDMes.contents[0].text = result.beltScaleData.offsetCorrections[1].name;
                        meshJPZDMes.contents = meshJPZDMes.contents;
                      } else {
                        meshJPZD.setEnabled(false);
                      }
                    }
                    // meshJPQDMes.contents[0]= ;
                  }
                })
              });
            })
            .catch(error => {
              // console.error('Error fetching data:', error);
            });
        }
        // 初始数据加载
        fetchData();
        // 每隔 2 秒刷新一次数据
        setInterval(fetchData, 2000);
      };
    }
  },
  destroyed() { },
  methods: {},
};

function setTG(p, mesh, manager) {
  // console.log("setTG", p, mesh);
  switch (p) {
    case 0:
      // mesh.position.y = 10;
      // mesh.rotation.z = 0;
      manager.setValue({
        target: mesh,
        props:
          [
            { property: ['customPositionY'], value: 10 },

            { property: ['customRotationZ'], value: 180 },
          ],
      },
        { duration: 3 }
      )
      break;
    case 1:
      //10.406500192601385
      // mesh.position.y = 6.34;
      // mesh.rotation.z = 0;
      manager.setValue({

        target: mesh,
        props:
          [
            { property: ['customPositionY'], value: 6.2 },

            { property: ['customRotationZ'], value: 180 },
          ],
      },
        { duration: 3 }
      )
      break;

    case 2:
      // mesh.position.y = 8.4;
      // mesh.rotation.z = 0.2;
      manager.setValue({
        target: mesh,
        props:
          [
            { property: ['customPositionY'], value: 8.4 },

            { property: ['customRotationZ'], value: 170 },
          ],
      },
        { duration: 3 }
      )
      break;

    case 3:
      // mesh.position.y = 8.4;
      // mesh.rotation.z = -10;

      manager.setValue({
        target: mesh,
        props:
          [
            { property: ['customPositionY'], value: 8.4 },

            { property: ['customRotationZ'], value: 190 },
          ],
      },
        { duration: 1.5 }
      )
      break;

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
